export default {
  approval:{
    leader:'上级',
    applicant:'申请人',
    tab1:'金币发放申请',
    tab2:'道具发放申请',
    tab3:'金币审批',
    tab4:'道具审批',

    applyTime:'申请时间',
    userID:'用户ID',

    applyTimeAndUser:'申请人&申请时间',

    applyStartTime:'申请开始时间',
    applyEndTime:'申请结束时间',
    status:'状态',

    addApply:'发放申请',

    coin_total:'发放总金额',
    coin_total_1:'发放总金币数量',
    real_money:'实际总金额（美元）',
    user_count:'发放人数',
    reason:'发放理由',
    check_name:'审批人',


    checkDel:'确认删除该申请？删除后对方将无法看到该申请。',
    giveType:'赠送类型',
    reject:'拒绝',
    pass:'通过',

    passAndTime:'通过人&通过时间',
    rejectAndTime:'拒绝人&拒绝时间',
    rejectReason:'拒绝原因',

    suerPass:'确认操作通过该申请吗？',

    next:'下一步',
    total_price:'消耗额度',
  }
}



// WEBPACK FOOTER //
// ./src/language/approval-zh-cn.js